import script from "./ProfileResume.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileResume.vue?vue&type=script&setup=true&lang=js"

import "./ProfileResume.vue?vue&type=style&index=0&id=4e9583f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9583f9"]])

export default __exports__